// extracted by mini-css-extract-plugin
module.exports = {"preloaderWrap":"styles_preloaderWrap__mPjgE","preloader":"styles_preloader__bQ_QZ"};